import { render } from "./EditarCompra.vue?vue&type=template&id=573c750e"
import script from "./EditarCompra.vue?vue&type=script&lang=js"
export * from "./EditarCompra.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__